import { Dispatch, SetStateAction } from 'react';
import Modal from '@/components/modal/Modal';
import { MediumText, RegularText } from '@/lib/Text';
import { colors } from '@/lib/colors';
import { Col, Row } from '@/lib/utils';

type Props = {
    setIsVisible: Dispatch<SetStateAction<boolean>>;
    onClickConfirm?: () => void;
};

const ModalPermissionSuccessAlert = ({ setIsVisible, onClickConfirm }: Props) => {
    const handleConfirm = () => {
        onClickConfirm && onClickConfirm();
    };

    return (
        <Modal
            setIsVisible={setIsVisible}
            whiteViewWidth={495}
            whiteViewHeight={200}
            borderRadius={25}
            onClose={handleConfirm}
        >
            <div className="flex flex-col justify-center items-start py-[17px] px-[34px]">
                <RegularText fontSize={20} lineHeight={30} color={colors.Text_1} letterSpacing={-0.4}>
                    변경된 권한이 적용됐어요
                </RegularText>
                {/* <RegularText
                    fontSize={20}
                    lineHeight={30}
                    color={colors.Text_1}
                    className="mb-[16px]"
                    letterSpacing={-0.4}
                >
                    강사 및 회원에게 알림이 발송돼요
                </RegularText> */}
                {/* <MediumText fontSize={20} lineHeight={30} color={colors.Text_1} letterSpacing={-0.4}>
                    변경 내용을 적용할까요?
                </MediumText> */}
                <Row className="gap-[12px] absolute bottom-[34px] right-[17px]">
                    {/* <Col
                        className=" justify-center items-center bg-[#F4F5F7] w-[110px] h-[40px] rounded-[9px] cursor-pointer"
                        onClick={() => setIsVisible(false)}
                    >
                        <RegularText fontSize={16} lineHeight={21} color={colors.Text_1}>
                            취소
                        </RegularText>
                    </Col> */}
                    <Col
                        className=" justify-center items-center bg-primary w-[110px] h-[40px] rounded-[9px] cursor-pointer"
                        onClick={handleConfirm}
                    >
                        <RegularText fontSize={16} lineHeight={21} color={colors.white}>
                            확인
                        </RegularText>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default ModalPermissionSuccessAlert;
